import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { VerificationAttemptLimits } from '@fantaz/shared/data-access/api';

@Component({
  selector: 'fz-register-credit-card-failure-dialog',
  templateUrl: './register-credit-card-failure-dialog.component.html',
  styleUrls: ['./register-credit-card-failure-dialog.component.scss'],
})
export class RegisterCreditCardFailureDialogComponent
  implements OnInit, OnDestroy
{
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    @Inject(MAT_DIALOG_DATA)
    public data: { attempts: VerificationAttemptLimits },
  ) {}

  get attempts(): number | undefined {
    if (this.data?.attempts?.current?.CC > -1) {
      return this.data.attempts.max.CC - this.data.attempts.current.CC;
    }

    return undefined;
  }

  get title(): string {
    const remainingAttempts = this.attempts;

    if (remainingAttempts && remainingAttempts > 0) {
      return "Sorry, we couldn't verify your credit card.";
    }

    return 'Credit card verification attempts exceeded.';
  }

  get content(): string {
    const remainingAttempts = this.attempts;

    if (remainingAttempts && remainingAttempts > 0) {
      return `Don't worry, you can still continue with the verification of your player profile by editing your credit card or uploading a clear picture of your ID document.`;
    }

    return `We're unable to verify your credit card information and you have exhausted your maximum attempts. Please consider another method of verification or reach out to our Customer Support for help`;
  }
  ngOnInit(): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { m: 'register-cc-fail' },
      replaceUrl: true,
      queryParamsHandling: 'merge',
    });
  }

  ngOnDestroy(): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { m: null },
      replaceUrl: true,
      queryParamsHandling: 'merge',
    });
  }
}
